import React from 'react';
import { DownloadIcon, ThermometerIcon, MoonIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Descarga',
    desc: 'Realizas el vaciado mental de 3 minutos para cerrar los ciclos de pensamiento.',
    icon: DownloadIcon
  }, {
    num: '2',
    title: 'Hackeo',
    desc: 'Aplicas la técnica de descompresión térmica para bajar la temperatura de tus órganos.',
    icon: ThermometerIcon
  }, {
    num: '3',
    title: 'Apagado',
    desc: 'Sigues la secuencia de respiración somática 4-7-8 para entrar en sueño profundo.',
    icon: MoonIcon
  }];
  return <section className="relative z-10 py-24 px-4" data-id="element-67">
      <div className="max-w-5xl mx-auto" data-id="element-68">
        <FadeIn data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16" data-id="element-70">
            Cómo Funciona
          </h2>
        </FadeIn>

        <div className="relative" data-id="element-71">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-blue-500/0 via-blue-500/30 to-blue-500/0 z-0" data-id="element-72"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-73">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <FadeIn key={index} delay={index * 0.2} className="flex flex-col items-center text-center" data-id="element-74">
                  <div className="w-24 h-24 rounded-full bg-[#0a0e27] border-2 border-blue-500/30 flex items-center justify-center mb-6 relative shadow-[0_0_20px_rgba(96,165,250,0.15)]" data-id="element-75">
                    <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-amber-500 text-slate-900 font-bold flex items-center justify-center text-sm" data-id="element-76">
                      {step.num}
                    </div>
                    <Icon className="w-10 h-10 text-blue-400" data-id="element-77" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4 font-serif" data-id="element-78">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed max-w-xs" data-id="element-79">
                    {step.desc}
                  </p>
                </FadeIn>;
          })}
          </div>
        </div>
      </div>
    </section>;
}